export default {
  appHost: process.env.VUE_APP_HOST,
  imgHost: process.env.VUE_APP_HOST_IMG,
}
